export default __webpack_public_path__ + "static/media/footer_bg.73508852.jpg";